import { useState } from 'react'
import {
  Column,
  Container,
  ModalBottomSheet,
  Picture,
  Row,
  Spacer,
  Text
} from '@smuchile/pkg-unimarc-components'
import { getBemId } from '@smuchile/pkg-unimarc-components/helpers'
import { ButtonStatus } from '@smuchile/pkg-unimarc-hooks/shared/interfaces/IOrderForm'

interface ModalConfirmChangeAddressProps {
  confirmNewAddress?: boolean
  confirmAddressModalImage: string
  isMobile: boolean
  openModalConfirmChangeAddress: boolean
  confirmUserAddress: (value?: boolean) => void
  setOpenModalConfirmChangeAddress: React.Dispatch<
    React.SetStateAction<boolean>
  >
  setAddressFromMap?: () => void
}
export const ModalConfirmChangeAddress = ({
  confirmNewAddress,
  confirmAddressModalImage,
  isMobile,
  openModalConfirmChangeAddress,
  confirmUserAddress,
  setOpenModalConfirmChangeAddress,
  setAddressFromMap
}: ModalConfirmChangeAddressProps) => {
  const customMaxWidth = isMobile ? '265px' : '340px'
  const customMargin = isMobile ? '15.5px 0 0 0' : '37pxpx 0 0 0'
  const [loadingBtn, setLoadingBtn] = useState<boolean>(false)
  const [secondaryBtnStatus, setSecondaryBtnStatus] =
    useState<ButtonStatus>('initial')

  const handleChangeAddress = () => {
    setLoadingBtn(true)
    setSecondaryBtnStatus('disabled')
    if (confirmNewAddress) {
      return setAddressFromMap()
    }

    return confirmUserAddress()
  }

  const handleKeepAddress = () => {
    setLoadingBtn(false)
    setSecondaryBtnStatus('initial')
    setOpenModalConfirmChangeAddress(false)
  }

  return (
    <ModalBottomSheet
      customHeightContent='100%'
      dissableCloseOutside={true}
      id={getBemId('modalConfirmChangeAddress', 'container')}
      isLoadingBtn={loadingBtn}
      isMobile={isMobile}
      isOpen={openModalConfirmChangeAddress}
      isWindowBlocked={true}
      maxWidthModal='440px'
      minHeightModal='500px'
      minHeightModalMobile='500px'
      onClose={handleKeepAddress}
      primaryBtnLabel='Sí, continuar'
      primaryCTA={handleChangeAddress}
      secondaryBtnLabel='No gracias'
      secondaryBtnStatus={secondaryBtnStatus}
      secondaryCTA={handleKeepAddress}
    >
      <>
        <Column
          alignItems='center'
          justifyContent='center'
          width='250px'
        >
          <Picture
            alt='sandwich'
            height='auto'
            id={getBemId('modalConfirmChangeAddress', 'image')}
            src={confirmAddressModalImage}
            width={isMobile ? '180px' : '243px'}
          />
          <Container
            justifyContent='center'
            margin={customMargin}
          >
            <Text
              fontSize='xl'
              fontWeight='semibold'
              id={getBemId('modalConfirmChangeAddress', 'title')}
              textAlign='center'
            >
              Que no se te escapen...
            </Text>
          </Container>
        </Column>
        <Spacer.Horizontal size={isMobile ? 16 : 12} />
        <Row maxWidth={customMaxWidth}>
          <Text
            fontWeight='regular'
            id={getBemId('modalConfirmChangeAddress', 'description')}
            isFlex
            textAlign='center'
          >
            Recuerda que si haces este cambio, alguno de tus productos podrían
            estar agotados ¿deseas continuar?
          </Text>
        </Row>
      </>
    </ModalBottomSheet>
  )
}
